module.exports = __webpack_public_path__ + "media/images/logo_2025-0b3791ad6e9005afcd7e228e34407b3d.svg";